import { useEffect } from "react";
import { useParams } from "react-router-dom";
import {
    fetchScreening,
    selectScreeningByIMO,
    selectScreeningError,
    selectScreeningLoading
} from "../features/screeningSlice";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { ScreeningHeader } from "../components/screening/ScreeningHeader";
import { ScreeningTabs } from "../components/screening/ScreeningTabs";
import { useCapabilities } from "../hooks/user";
import { Capability } from "../types/inspections/UserCapabilities";
import { MarketingPage } from "@idwal/idwal-react-components";
import { userSliceSelector } from "../features/userSlice";
import { ScreeningError } from "../components/screening/ScreeningError";

export const Screening = () => {
    const dispatch = useAppDispatch();
    const { imo } = useParams();

    const user = useAppSelector(userSliceSelector);
    const loading = useAppSelector(selectScreeningLoading);
    const error = useAppSelector(selectScreeningError);
    const data = selectScreeningByIMO(imo);

    const { capabilities } = useCapabilities([Capability.CAP_FLEETAPP_VIEW_SCREENING]);

    useEffect(() => {
        if (imo && user.UserToken) {
            dispatch(fetchScreening(imo));
        }
    }, [imo, user.UserToken]);

    if (!capabilities[Capability.CAP_FLEETAPP_VIEW_SCREENING] && !loading) {
        return (
            <div className="h-full flex flex-column align-items-center justify-content-center">
                <div id="marketing-container">
                    <MarketingPage
                        type="screening"
                        learnMoreCallback={() => {}}
                        requestDemoCallback={() => {}}
                        showLogo={true}
                    />
                </div>
            </div>
        )
    }

    if (error) {
        return <ScreeningError />
    }

    return (
        <div className={"inspection-page-wrapper"}>
            <div>
                <ScreeningHeader data={data} loading={loading} />
                <ScreeningTabs data={data} loading={loading} />
            </div>
        </div>
    );
};
